export type ProtocolOption = {
    value: string;
    label: string;
};

export const PROTOCOL_OPTIONS: ProtocolOption[] = [
    {
        value: 'https://',
        label: 'https://',
    },
    {
        value: 'http://',
        label: 'http://',
    },
];

/**
 * Takes a domain string and returns a "good" looking domain with a protocol
 * prepended. Will ensure no duplicate protocol is added.
 *
 * @param {ProtocolOption} protocol - The protocol to use
 * @param {string} domain - The domain to normalize
 *
 * @return {string} The normalized domain string
 */
export function getNormalizedDomain(protocol: ProtocolOption, domain: string): string {
    const cleanedDomain = domain.replace(/(https:\/\/|http:\/\/)/g, '').trim();

    if (!cleanedDomain) {
        return '';
    }

    return `${protocol.value}${cleanedDomain}`;
}
